export const DEFAULT_SIGN_COORDS = {
  page: 1,
  llx: '10',
  lly: '747',
  urx: '110',
  ury: '797',
}

export const MAIN_FILES_LIST_MAX_HEIGHT = 360

/** Số file tối đa mỗi lần gọi VNPT createSavisSign */
export const SIGN_BATCH_SIZE_MAX = 100

/** @deprecated dùng SIGN_BATCH_SIZE_MAX */
export const SIGN_BATCH_SIZE = SIGN_BATCH_SIZE_MAX

/** Số file tối đa mỗi request PUT signed-file/batch */
export const SIGNED_FILE_BATCH_SIZE = 99

/** Chia file thành các lượt gần bằng nhau, mỗi lượt ≤ SIGN_BATCH_SIZE_MAX */
export const splitIntoEvenSignChunks = items => {
  const total = items.length
  if (total === 0) return []
  if (total <= SIGN_BATCH_SIZE_MAX) return [items]

  const roundCount = Math.ceil(total / SIGN_BATCH_SIZE_MAX)
  const baseSize = Math.floor(total / roundCount)
  const remainder = total % roundCount

  const chunks = []
  let offset = 0
  for (let i = 0; i < roundCount; i++) {
    const size = baseSize + (i < remainder ? 1 : 0)
    chunks.push(items.slice(offset, offset + size))
    offset += size
  }
  return chunks
}

export const getSignRoundCount = fileCount =>
  splitIntoEvenSignChunks(Array.from({ length: fileCount || 0 })).length

export const getSignChunkSizes = fileCount =>
  splitIntoEvenSignChunks(Array.from({ length: fileCount || 0 })).map(
    chunk => chunk.length
  )

export const SIGN_STEP_KEYS = {
  LEADER_SIGN: 'LEADER_SIGN',
  LEAD_KTAT_SIGN: 'LEAD_KTAT_SIGN',
  BOD_SIGN: 'BOD_SIGN',
  DIGITAL_SIGN: 'DIGITAL_SIGN',
}
